/** Locale keys for SERVICE_CATALOG + category guide timelines (see public/locales/te.xml). */

export function serviceTitle(code, t, fallback) {
  return t(`svc.${code}.title`, fallback);
}

export function serviceDesc(code, t, fallback) {
  return t(`svc.${code}.desc`, fallback);
}

export function serviceStartingPrice(code, t, fallback) {
  if (!fallback || /^price on request$/i.test(String(fallback).trim())) {
    return t('services.price_on_request', 'Price on request');
  }
  return t(`svc.${code}.starting_price`, fallback);
}

export function categoryTimeline(category, t, fallback) {
  return t(`guide.timeline.${category}`, fallback);
}
